import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import DebouncedInput from '../../molecules/DebouncedInput'
import FlexColumn from '../../molecules/FlexColumn'
import SydButton from '../../commonDesign/Button'

/**
 * Shared toolbar for blueprint presentation tables. Renders a flex row with
 * left content (displayName + optional search), right content (export + configure),
 * then children (table, truncation warning, etc.).
 */
function BlueprintTableToolbar ({
  className,
  displayName,
  hasSearch,
  globalFilter,
  onGlobalFilterChange,
  showExport,
  exportButton,
  hasColumnConfig,
  onConfigClick,
  configModal,
  children
}) {
  const showToolbarActions = showExport || hasColumnConfig || hasSearch
  const showLeft = !!displayName || hasSearch
  const showToolbarRow = showLeft || showToolbarActions

  return (
    <FlexColumn className={clsx('gap-xs', className)}>
      {showToolbarRow
        ? (
          <div className='flex flex-row justify-between items-center'>
            <div className='flex flex-col gap-xs'>
              {displayName
                ? <div className='opal-heading opal-heading-2 font-size-lg'>{displayName}</div>
                : null}
              {hasSearch
                ? (
                  <DebouncedInput
                    placeholder='Search'
                    delay={300}
                    onChange={onGlobalFilterChange}
                    style={{ minWidth: '14rem', maxWidth: '18rem' }}
                  />
                )
                : null}
            </div>
            {showToolbarActions
              ? (
                <div className='flex flex-row gap-sm'>
                  {showExport ? exportButton : null}
                  {hasColumnConfig
                    ? (
                      <SydButton
                        onClick={onConfigClick}
                        variant='outline'
                        size='xs'
                        icon='settings'
                      >
                        Configure
                      </SydButton>
                    )
                    : null}
                </div>
              )
              : null}
          </div>
        )
        : null}
      {children}
      {configModal}
    </FlexColumn>
  )
}

BlueprintTableToolbar.propTypes = {
  className: PropTypes.string,
  displayName: PropTypes.string,
  hasSearch: PropTypes.bool,
  globalFilter: PropTypes.string,
  onGlobalFilterChange: PropTypes.func,
  showExport: PropTypes.bool,
  exportButton: PropTypes.node,
  hasColumnConfig: PropTypes.bool,
  onConfigClick: PropTypes.func,
  configModal: PropTypes.node,
  children: PropTypes.node.isRequired
}

BlueprintTableToolbar.defaultProps = {
  className: null,
  displayName: null,
  hasSearch: false,
  globalFilter: '',
  onGlobalFilterChange: () => {},
  showExport: false,
  exportButton: null,
  hasColumnConfig: false,
  onConfigClick: () => {},
  configModal: null
}

export default BlueprintTableToolbar
